import styles from './ListHeader.module.css';

const DEFAULT_COLUMNS = [
	{ label: 'Rank', className: styles.rankWrapper },
	{ label: 'Contents', className: styles.contentsWrapper },
	{ label: 'Descrioption', className: styles.descrioptionWrapper },
	{ label: 'Creator', className: styles.creatorWrapper },
	{ label: 'Country', className: styles.countryContainer },
	{ label: 'Views', className: styles.viewsWrapper },
	{ label: 'Engagement', className: styles.engagementWrapper },
	{ label: 'Commetns', className: styles.commetnsWrapper },
	{ label: 'Posted Date', className: styles.postedDateWrapper },
];

const ListHeader = ({ columns = DEFAULT_COLUMNS }) => {
	return (
		<div className={styles.headerWrapper}>
			{columns.map(({ label, className }) => (
				<div key={label} className={className}>
					<span className={styles.label}>{label}</span>
				</div>
			))}
		</div>
	);
};

export default ListHeader;
